export const css = {
	root: '_2tBRHHj9',
	scoreContainer: '_3Ee5V6Jg',
	title: '_2OxdRqO9',
	wrapper: 'daJTJmWY',
	domain: 'T2kMMuOV',
	field: '_3PyWb3IB',
	bar: '_3sTaDA0r',
	lowScore: '_3wEE_bix',
	midScore: '_2iUIcR0x',
	highScore: '-cOu-Whj',
	barZero: '_127N8rVw',
	barLow: '_1KNb94Qg',
	barMid: '_3MF6IDA_',
	barHigh: '_3wdnmJSF',
	barscore: '_2iJBcQU6',
	legend: '_1fy1De5y',
	topicHeader: '_2mWHXJfn',
	header: '_3y9OjYbx',
	topic: 'gxIjoY5A',
	topicTitle: '_2l67ta9E',
	topicStatus: '_26L3Fm5Y',
	statusLabel: '_3Gr3dBDe',
	summary: '_3-MNEHhD',
	topicSection: '_2zmbVCpR',
	section: 'FQU2gO31',
	sections: '_2sEQxeRj',
	progressItem: '_3GTOt89c',
	icon: '_1V864zHO',
	sectionLabel: '_3dCBmYo4',
	sectionTitle: '_1dtSVBV0',
	sectionStatusLabel: '_3A0jzhcU',
	inexperienced: '_3x8f5Soc',
	improvement: 'mRm8zOh6',
	proficient: 'SbN-da_1',
	notApplicable: '_1r_QsEWK',
	' _key': 'prepost-viz/progress-viz'
};

export default css;
